import { CopyQuote } from 'quoting/new-quote/copy-quote';
import { Redirect, useParams } from 'react-router-dom';
import { PageLoading } from 'shared/components/page-loading';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { useGetQuote } from 'shared/mutations/quotes';
import { QuoteRouteParams } from 'shared/types/routing';
import { ROUTES } from './routes';

export function CopyQuoteResolver() {
  const userPermissions = useUserPermissions();
  const { quoteId } = useParams<QuoteRouteParams>();
  const { data } = useGetQuote(quoteId);

  if (!userPermissions.includes('abg-retail.quoting.view')) {
    return <Redirect to={ROUTES.login} />;
  }

  if (!data) {
    return <PageLoading />;
  }

  return <CopyQuote quote={data} />;
}
